export const classNameIf = (className: string, condition: boolean) => {
  return condition ? className : "";
}

export const excludeClickEventIf = (condition: boolean) => classNameIf("exclude-click-event", condition);
